{
	"meta": {
		"home": {
			"title": "KISS.cat",
			"description": "Your KISS.cat home: sign in and launch your apps."
		},
		"invite": {
			"title": "Accept invitation · KISS.cat",
			"description": "Join a KISS.cat workspace"
		},
		"integrations": {
			"title": "Integrations · KISS.cat",
			"description": "Connect the tools your workspace uses so they work alongside your tickets"
		},
		"profile": {
			"title": "Profile · KISS.cat",
			"description": "Your KISS.cat profile"
		},
		"agents": {
			"title": "Agents · KISS.cat",
			"description": "Manage the agents connected to your KISS.cat account"
		},
		"members": {
			"title": "Members · KISS.cat",
			"description": "Manage the people in your KISS.cat workspace."
		},
		"billing": {
			"title": "Billing · KISS.cat",
			"description": "Manage your KISS.cat workspace billing."
		},
		"tokens": {
			"title": "API tokens · KISS.cat",
			"description": "Workspace tokens for the public REST API and integrations."
		}
	},
	"nav": {
		"apps": "Apps",
		"account": "Account",
		"accounts": "Accounts",
		"addAccount": "Add account",
		"home": "Home",
		"skipToContent": "Skip to content",
		"billing": "Billing",
		"members": "Members",
		"agents": "Agents",
		"tokens": "API tokens",
		"integrations": "Integrations",
		"scope": "Scope",
		"new": "new",
		"profile": "Profile",
		"sections": "Sections",
		"collapse": "Collapse sidebar",
		"expand": "Expand sidebar",
		"openMenu": "Open menu",
		"closeMenu": "Close menu",
		"menu": "Menu",
		"primary": "Primary",
		"expandNav": "Expand navigation",
		"collapseNav": "Collapse navigation",
		"brandHome": "KISS.cat home"
	},
	"theme": {
		"toggle": "Switch theme",
		"light": "Light",
		"dark": "Dark",
		"system": "System"
	},
	"common": {
		"loading": "Loading...",
		"cancel": "Cancel",
		"tryAgain": "Try again"
	},
	"home": {
		"signInTitle": "Welcome to KISS.cat",
		"signInHint": "Enter your email to sign in or create your account.",
		"continue": "Continue with email",
		"codeSentTo": "We sent a code to <strong>{{email}}</strong>.",
		"soon": "soon",
		"trust": {
			"passwordless": "Passwordless",
			"secure": "Secure by design",
			"private": "Private"
		}
	},
	"hub": {
		"greeting": "Welcome back",
		"greetingNamed": "Welcome back, {{name}}",
		"subtitle": "Pick up where you left off across your KISS.cat apps.",
		"appsLabel": "Your apps",
		"open": "Open",
		"comingSoon": "Coming soon",
		"new": "new",
		"apps": {
			"tasks": {
				"name": "Tasks",
				"description": "Plan and track work on boards."
			},
			"scope": {
				"name": "Scopes",
				"description": "Helps you get from idea to backlog."
			},
			"help": {
				"name": "Help",
				"description": "Answer support requests and track tickets."
			},
			"notes": {
				"name": "Notes",
				"description": "Capture ideas and write things down."
			},
			"plans": {
				"name": "Plans",
				"description": "Map out projects and timelines."
			}
		}
	},
	"suspended": {
		"title": "<strong>{{workspace}}</strong> is suspended",
		"body": "We could not collect a payment, so this workspace moved to the free plan and your access is paused for now.",
		"guidance": "A workspace admin needs to pay the outstanding balance to reactivate it. As soon as the payment goes through, your access comes back.",
		"otherWorkspaces": "You can keep working in another workspace:"
	},
	"disabled": {
		"title": "Your access to <strong>{{workspace}}</strong> is turned off",
		"body": "An admin has disabled your seat in this workspace, so you cannot open it for now.",
		"guidance": "Ask a workspace admin to turn your seat back on. Once they do, your access comes straight back, no need to sign in again.",
		"otherWorkspaces": "You can keep working in another workspace:"
	},
	"auth": {
		"email": "Email",
		"enterCode": "Enter your code",
		"sendFailed": "Couldn't send a code. Please try again.",
		"codeSentTo": "We sent a code to",
		"code": "Code",
		"verify": "Verify",
		"badCode": "That code is invalid or expired.",
		"resend": "Resend code",
		"resendIn": "Resend in {{seconds}}s",
		"resent": "We sent another code.",
		"useAnotherEmail": "Use another email",
		"consent": "By continuing you agree to our <terms>Terms</terms> and <privacy>Privacy Policy</privacy>.",
		"signOut": "Sign out",
		"emailRequired": "Enter your email"
	},
	"invite": {
		"byName": "{{inviter}} invited you to join as {{role}}.",
		"byEmail": "You've been invited to join as {{role}}.",
		"signInHint": "We'll email a 6-digit code to {{email}} to confirm it's you.",
		"emailCode": "Email me a code",
		"joining": "Joining {{workspace}}...",
		"verifyAndJoin": "Verify and join",
		"accept": "Accept invitation",
		"acceptFailed": "Couldn't accept the invite. Please try again.",
		"wrongAccount": "This invite is for {{invited}}, but you are signed in as {{current}}.",
		"signOutToSwitch": "Sign out to accept as {{invited}}",
		"invalid": {
			"title": "This invite link is no longer valid",
			"body": "It may have expired, already been used, or been revoked. Ask whoever invited you to send a new one."
		}
	},
	"billing": {
		"title": "Billing",
		"subtitle": "Your plan, invoices and seats.",
		"loading": "Loading billing",
		"noWorkspace": {
			"title": "No workspace selected",
			"body": "Pick a workspace from your account to see its plan and seats."
		},
		"unavailable": {
			"title": "Billing is unavailable right now",
			"body": "We could not load your plan. Refresh the page in a moment."
		},
		"hero": {
			"eyebrow": "Free plan",
			"heading": "Your first seat is always free.",
			"body": "Ready to bring your team in? Start the Team plan and only pay for the seats you add.",
			"cta": "Start the Team plan",
			"price": "Team plan is {{price}} per extra seat / month. Cancel any time.",
			"pricePending": "Team plan bills per extra seat. Cancel any time.",
			"notConfigured": "Billing is not set up for this workspace yet. Seat pricing is a preview."
		},
		"plan": {
			"team": "Team plan",
			"free": "Free plan",
			"metaRenews": "{{cost}} / month · renews {{date}}",
			"metaMonthly": "{{cost}} / month",
			"perMonth": "/ month",
			"revertsToFree": "Reverts to the free plan on {{date}}. You keep your team until then.",
			"manage": "Manage billing",
			"manageMembers": "Manage members and seats"
		},
		"pastDue": {
			"title": "Payment failed",
			"text": "We could not take your last payment. Update your billing details to keep your team active.",
			"textDeadline": "We could not take your last payment. We will keep retrying until {{date}}. If it is still unpaid then, your workspace moves to the free plan and your billed members are paused until you pay.",
			"fix": "Fix payment"
		},
		"suspended": {
			"title": "Workspace moved to the free plan",
			"body": "We could not collect payment within 14 days, so your workspace is now on the free plan and your billed members are paused. Pay the outstanding balance to reactivate everyone right away.",
			"reactivate": "Reactivate and pay",
			"badge": "Members paused",
			"meta_one": "{{count}} member, {{active}} active and {{paused}} paused",
			"meta_other": "{{count}} members, {{active}} active and {{paused}} paused",
			"outstanding": "Outstanding balance",
			"outstandingSub": "The unpaid invoice from your last period. Clear it to lift the pause.",
			"pausedKey": "Members paused",
			"pausedSub": "{{names}} cannot access this workspace until payment is made.",
			"pausedSubNone": "Billed members cannot access this workspace until payment is made."
		},
		"invoices": {
			"title": "Payment history",
			"loading": "Loading invoices",
			"unavailable": "Payment history is unavailable right now. Refresh the page in a moment.",
			"viewAll": "View all invoices in Stripe",
			"empty": {
				"title": "No invoices yet",
				"body": "Your invoices will appear here after your first payment."
			},
			"status": {
				"paid": "Paid",
				"unpaid": "Unpaid"
			}
		},
		"status": {
			"pastDue": "Past due",
			"ending": "Ending",
			"active": "Active",
			"canceled": "Cancelled",
			"incomplete": "Incomplete",
			"paused": "Paused",
			"unknown": "Unknown"
		}
	},
	"profile": {
		"title": "Profile",
		"subtitle": "Your name, photo and account, shared across kiss.cat.",
		"detailsTitle": "Your details",
		"account": "Account",
		"description": "Your name and photo are part of your account, shared across all of kiss.cat.",
		"nameLabel": "Display name",
		"saved": "Saved",
		"saveFailed": "Couldn't save. Please try again.",
		"avatar": {
			"add": "Add photo",
			"change": "Change photo",
			"remove": "Remove",
			"save": "Save photo",
			"saved": "Photo updated",
			"badType": "Choose a PNG, JPEG or WebP image.",
			"tooLarge": "That image is over 5 MB.",
			"failed": "Couldn't upload. Please try again.",
			"removeFailed": "Couldn't remove your photo. Please try again."
		}
	},
	"account": {
		"namePlaceholder": "Your name",
		"saveName": "Save",
		"workspaces": "Workspaces",
		"current": "current",
		"switch": "Switch",
		"switchWorkspace": "Switch workspace",
		"nameRequired": "Enter a name"
	},
	"agents": {
		"title": "Agents",
		"subtitle": "Coding agents connected to your workspace."
	},
	"apiTokens": {
		"title": "API tokens",
		"subtitle": "Workspace tokens for the public REST API and integrations. Treat them like passwords: anyone with a token can act on this workspace.",
		"create": {
			"name": "Token name",
			"namePlaceholder": "CI deploy bot",
			"nameRequired": "Give the token a name",
			"expiry": "Expiry",
			"submit": "Create token"
		},
		"expiry": {
			"never": "Never",
			"30": "30 days",
			"90": "90 days",
			"365": "1 year"
		},
		"created": {
			"title": "Copy this token now",
			"warning": "This is the only time we will show it. Store it somewhere safe before you dismiss this.",
			"copy": "Copy",
			"copied": "Copied",
			"dismiss": "Dismiss"
		},
		"list": {
			"loading": "Loading tokens",
			"prefix": "Prefix",
			"created": "Created {{date}}",
			"lastUsed": "Last used {{value}}",
			"expires": "Expires {{value}}",
			"never": "Never",
			"revoke": "Revoke",
			"confirmRevoke": "Revoke?",
			"cancel": "Cancel"
		},
		"empty": {
			"title": "No tokens yet",
			"description": "Create a token to call the public API from a script or integration."
		}
	},
	"integrations": {
		"title": "Integrations",
		"subtitle": "Connect the tools your workspace uses so they work alongside your tickets."
	},
	"github": {
		"title": "GitHub",
		"subtitle": "Connect GitHub so pull requests move your tickets along the board.",
		"loading": "Loading GitHub status",
		"loadingRepos": "Loading repositories",
		"notConfigured": "GitHub isn't configured",
		"connectHint": "Connect GitHub to link every repository your GitHub App is installed on to this workspace.",
		"connect": "Connect GitHub",
		"connectedToast": "GitHub connected",
		"connectedNoReposToast": "GitHub connected, but no repositories synced",
		"connected": "Connected",
		"connectedCount_one": "Connected · {{count}} repository",
		"connectedCount_other": "Connected · {{count}} repositories",
		"disconnect": "Disconnect",
		"confirmDisconnect": "Disconnect?",
		"disconnectedToast": "GitHub disconnected",
		"adminOnly": "Only an admin can change this.",
		"refresh": "Refresh repos",
		"sync": "Sync repositories",
		"noReposTitle": "Connected, but no repositories are synced to this workspace",
		"noReposBody": "Make sure the GitHub App is installed for this workspace, then sync the repositories.",
		"helper": "Any PR in these repos whose title, branch, or description mentions a ticket key (like KISS-123) automatically links to that ticket and moves it along the board.",
		"remove": "Remove repository",
		"confirmRemove": "Remove?",
		"removedTitle": "Removed repositories",
		"removedHint": "Removed repos are ignored until you re-add them.",
		"readd": "Re-add",
		"cancel": "Cancel"
	},
	"connections": {
		"loading": "Loading agents",
		"title": "Connected agents",
		"subtitle": "AI agents you have given access to your tasks.",
		"connect": "Connect an agent",
		"active": "Active",
		"lastUsed": "Last used {{value}}",
		"neverUsed": "Not used yet",
		"registeredAs": "registered as {{name}}",
		"accessExpired": "Access expired",
		"reconnectNeeded": "Reconnect needed",
		"rename": "Rename",
		"renameField": "New name for this agent",
		"save": "Save",
		"cancel": "Cancel",
		"revoke": "Revoke",
		"confirmRevoke": "Revoke?",
		"reconnect": "Reconnect",
		"reconnectNote": "This adds a fresh connection. Remove the old one after.",
		"remove": "Remove",
		"confirmRemove": "Remove?",
		"scope": {
			"tasks": "Tasks",
			"tasksRead": "Read tasks",
			"tasksWrite": "Manage tasks",
			"read": "Read",
			"write": "Write"
		},
		"toast": {
			"renamed": "Agent renamed",
			"removed": "Agent removed",
			"revoked": "Access revoked"
		},
		"error": {
			"title": "Agents are unavailable right now",
			"body": "Refresh the page in a moment."
		},
		"empty": {
			"title": "No agents connected yet",
			"description": "Connect Claude Code, Cursor, or any MCP client to read and update your tasks from your agent."
		},
		"modal": {
			"title": "Connect an agent",
			"subtitle": "Add Claude Code, Cursor, or any MCP client to your tasks.",
			"copyLabel": "Copy the server URL",
			"copy": "Copy",
			"copied": "Copied",
			"copyThing": "Copy {{thing}}",
			"copiedThing": "Copied {{thing}}",
			"subjects": {
				"url": "the server URL",
				"command": "the command",
				"cursorConfig": "the Cursor config"
			},
			"copyFailed": "Could not copy. Copy it manually.",
			"addLabel": "Add it to your client",
			"done": "Done",
			"clients": {
				"claude": "Claude Code",
				"cursor": "Cursor",
				"other": "Other"
			},
			"claude": {
				"step1": "Run this command in your terminal:",
				"step2": "Your browser opens. Sign in and approve access.",
				"step3": "The agent shows up in this list. Rename it to anything you like."
			},
			"cursor": {
				"step1": "Add this to ~/.cursor/mcp.json, or .cursor/mcp.json in a project:",
				"step2": "Or add it from Cursor settings. Sign in when the browser opens."
			},
			"generic": {
				"step": "Add the server URL as an HTTP MCP server in your client's settings, then approve access in the browser."
			}
		}
	},
	"members": {
		"title": "Members",
		"subtitle": "People with access to this workspace.",
		"team": "Team",
		"count_one": "{{count}} member",
		"count_other": "{{count}} members",
		"invitePeople": "Invite",
		"rowMenu": "Actions for {{name}}",
		"groups": {
			"active": "Active",
			"pending": "Pending",
			"suspended": "Suspended"
		},
		"seat": {
			"free": "Free seat",
			"perMonth": "{{amount}} / mo"
		},
		"loading": "Loading members",
		"you": "You",
		"disabled": "Deactivated",
		"access": {
			"label": "Access for {{name}}",
			"none": "Deactivated"
		},
		"remove": "Remove",
		"removeAction": "Remove from workspace",
		"confirmRemove": "Remove",
		"removeConfirm": {
			"title": "Remove {{name}}?",
			"body": "They lose access to this workspace right away. You can invite them again later."
		},
		"cancel": "Cancel",
		"error": {
			"title": "Members are unavailable right now",
			"body": "Refresh the page in a moment."
		},
		"toast": {
			"invited": "Invitation sent to {{email}}",
			"roleChanged": "Role updated",
			"removed": "Removed {{name}}",
			"resent": "Invitation resent",
			"revoked": "Invitation revoked",
			"seatFreed": "Seat freed",
			"seatRestored": "Seat restored"
		},
		"invite": {
			"email": "Email",
			"emailPlaceholder": "teammate@acme.com",
			"emailRequired": "Enter an email",
			"role": "Role",
			"send": "Send invite",
			"seatNote": "An invited teammate takes a seat only once they accept."
		},
		"role": {
			"ADMIN": "Admin",
			"MEMBER": "Member"
		},
		"empty": {
			"title": "No members yet",
			"body": "Invite a teammate to collaborate in this workspace."
		},
		"pending": {
			"heading": "Pending invitations",
			"expires": "Invited, expires {{date}}",
			"tag": "Invited",
			"resend": "Resend",
			"revoke": "Revoke"
		},
		"seatLimit": {
			"title": "Upgrade to add teammates",
			"body": "Your workspace is on the free plan, which includes one seat. Upgrade to invite more teammates.",
			"upgrade": "Upgrade",
			"toast": {
				"title": "Upgrade to add more members",
				"body": "Your free plan includes one seat. Upgrade on the Billing page to add teammates."
			}
		},
		"paused": "Paused",
		"suspended": {
			"title": "Workspace moved to the free plan",
			"body": "We could not collect a payment, so this workspace moved to the free plan and your billed members are paused. Reactivate to restore their access.",
			"reactivate": "Reactivate and pay"
		}
	},
	"a11y": {
		"close": "Close",
		"dismiss": "Dismiss",
		"imagePreview": "Image preview"
	},
	"field": {
		"moreInfo": "More information"
	}
}
